export const styles = {
  menuPaper: {
    maxHeight: 300,
    width: 300,
  },
  menuItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    py: 1,
  },
  jobId: {
    fontWeight: "bold",
    fontSize: "10px",
  },
  statusChip: {
    fontSize: "0.7rem",
    height: 20,
    "& .MuiChip-label": {
      fontSize: "0.7rem",
      px: 1,
    },
    "& .MuiChip-icon": {
      fontSize: "0.8rem",
    },
  },
};
